import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../shared/components/base/base.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../store/app.reducer';
import {TitleService} from '../../shared/services/title.service';
import {MetadataService} from '../../shared/services/metadata.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.css'],
})
export class ImprintComponent extends BaseComponent implements OnInit {

  constructor(
      protected store: Store<AppState>,
      private metadataService: MetadataService,
      private titleService: TitleService) {
    super(store);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleService.setTitle($localize`Imprint`);

    this.metadataService.updateTags($localize`Imprint`,
        $localize`Find out, who is responsible for the Blitzshare platform.`,
        $localize`imprint contact`,
    );
  }

}
